import { NavigateFunction } from 'react-router-dom';

export const resetProcess = (navigate: NavigateFunction) => {
    navigate('/');
    navigate(0); // ### Force page refresh to delete React Context
    localStorage.clear();
};
